import { TableColumn } from "react-data-table-component";
import { FormGroup, Input } from "reactstrap";
import { IConfig, IUser } from "src/services/types";

import './style.css';
import { DropdownActionsUser } from "./DropdownActionsUser";
import { UserColumnItem } from "./UserColumnItem";

export const columnsUsers: (
    config: IConfig, 
    onActive: (item: IUser) => void, 
    onVerified: (item: IUser) => void,
    openModal: (item: IUser) => void,
    onDelete: (item: IUser) => void,
    onMoveAGroup: (item: IUser) => void,
    openNoteModal: (item: IUser) => void,
    openEditUserModal: (item: IUser) => void
) => TableColumn<IUser>[] = 
(config, onActive, onVerified, openModal, onDelete, onMoveAGroup, openNoteModal, openEditUserModal) => {
    const getBgSex = (value: string) => {
        switch (value) {
            case "Men":
                return "bg-info-light";
            case "Women":
                return "bg-danger-light";
            default:
            return "bg-primary-light";
        }
      }
      
    return (
[
    { 
      name: "N°",
      center: true,
      width: "70px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
        name: "USER",
        width: "200px",
        cell: function OrderItems(item) {
          return (
            <UserColumnItem
              item={item}
              openModal={openModal}
              openNoteModal={openNoteModal}
            />
          );
        }
    },
    {
      name: "EMAIL",
      width: "250px",
      selector: (row: IUser) => row.email,
    },
    {
      name: "GROUP",
      width: "110px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            {
              item?.group ? (
                <small
                    className="p-2 rounded"
                    style={{ backgroundColor: item?.group?.color || '#f5f5f5'}}
                >
                  <span>{item?.group?.name ? (item.group.name.length > 10 ? item.group.name.slice(0, 9) + '...' : item.group.name) : '-'}</span>
                </small>
              ) : '-'
            }
          </>
        );
      },
    },
    {
      name: "SEX INTEREST",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <small className={"px-2 py-2 rounded-3 " + getBgSex(item.sexInterest)}>
                {item.sexInterest}
            </small>
        );
      }
    },
    {
      name: "ACTIVE",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <FormGroup switch>
                <Input
                    type="switch"
                    checked={item.active}
                    onChange={() => {onActive(item)}}
                />
            </FormGroup>
        );
      }
    },
    {
      name: "VERIFIED BY PLAID",
      width: "150px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <FormGroup switch className="custom-switch">
                <Input
                    type="switch"
                    checked={!!item.isVerified}
                    onChange={() => {onVerified(item)}}
                />
            </FormGroup>
        );
      }
    },
    {
      name: "VERIFIED BY ADMIN",
      width: "150px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            <span className={"px-2 py-2 rounded-3 " + (item.isVerifiedByAdmin === null ? 'bg-secondary-light' : ( item.isVerifiedByAdmin ? 'bg-success-light' : 'bg-danger-light '))}>
                { item.isVerifiedByAdmin === null ? ' - ' : ( item.isVerifiedByAdmin ? 'Yes' : 'No' ) }
            </span>
          </>
        );
      }
    },
    {
      name: "OPTIONS",
      width: "100px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <DropdownActionsUser 
            item={item}
            openNoteModal={openNoteModal}
            onMoveAGroup={onMoveAGroup}
            openEditUserModal={openEditUserModal}
            onDelete={onDelete}
          />
        );
      }
    }
  ]
)}